export default {
  most_popular: '#{{rank}} Suosituin',
};
